import {Box} from '@dagster-io/ui-components';
import {ReCaptchaProvider} from 'next-recaptcha-v3';
import {Suspense, useState} from 'react';

import Card from '@/components/Card';
import EmailForm from '@/components/EmailForm';
import EmailSentConfirmation from '@/components/EmailSentConfirmation';
import OrDivider from '@/components/OrDivider';
import RecaptchaDisclaimer from '@/components/RecaptchaDisclaimer';
import SignInWithProvider from '@/components/SignInWithProvider';
import {MediumHeading} from '@/components/Text';
import {AuthProvider} from '@/utils/AuthProvider';
import {extractLoginAppSettings} from '@/utils/extractLoginAppSettings';

import RegionSwitcherLink from './RegionSwitcherLink';

const {recaptchaSiteKey} = extractLoginAppSettings();

const CARD_HEIGHT = '348px';

export default function SignIn() {
  const [didSendEmail, setDidSendEmail] = useState(false);

  if (didSendEmail) {
    return (
      <Card
        responsive
        style={{height: CARD_HEIGHT}}
        flex={{direction: 'column', justifyContent: 'center'}}
      >
        <EmailSentConfirmation description="If your email is known to us, we&rsquo;ll send you a sign in link." />
      </Card>
    );
  }

  return (
    <>
      <Card responsive>
        <Box flex={{direction: 'column', gap: 16, alignItems: 'stretch'}}>
          <MediumHeading style={{textAlign: 'center'}}>Sign in</MediumHeading>
          {/* Sign in button forms use `useSearchParams`, and must be wrapped in Suspense. */}
          <Suspense fallback={<div />}>
            <>
              <SignInWithProvider provider={AuthProvider.Google} />
              <SignInWithProvider provider={AuthProvider.GitHub} />
              <SignInWithProvider provider={AuthProvider.SSO} path="/sso-login" />
            </>
          </Suspense>
          <OrDivider />
          <ReCaptchaProvider reCaptchaKey={recaptchaSiteKey} useEnterprise>
            {/* Email form uses `useSearchParams`, and must be wrapped in Suspense. */}
            <Suspense fallback={<div />}>
              <EmailForm
                buttonLabel="Sign in with email"
                submitPath="/signin/email"
                onDidSendEmail={() => setDidSendEmail(true)}
              />
            </Suspense>
          </ReCaptchaProvider>
          <RecaptchaDisclaimer />
        </Box>
      </Card>
      <Box style={{textAlign: 'center'}} padding={{vertical: 16}}>
        <RegionSwitcherLink />
      </Box>
    </>
  );
}
